import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { getEMail, usePermissions } from "../../user/User"
import { fetchData } from "../../api/Axios"

const SharedAddressList = ({ filter }) => {
    const columns = [{
        Header: "Name",
        accessor: "name",
        Cell: ({ value }) => <Link to={"/player/" + value}>{value}</Link>
    }, {
        Header: "IP Adresse",
        accessor: "address"
    }, {
        Header: "Score",
        accessor: "score",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
    }]

    const { permissions } = usePermissions(getEMail())
    const [sharedAddresses, setSharedAddresses] = useState([])

    useEffect(() => {
        setSharedAddresses([])
        if (filter === undefined || filter === "") {
            return
        }
        if (permissions.addresses === undefined || !permissions.addresses) {
            return
        }

        fetchData("/api/addresses/" + filter, "IP Adressen konnten nicht geladen werden.", playerAddresses => {
            const ownIps = new Set((playerAddresses || []).map(entry => entry.address))
            if (ownIps.size === 0) {
                return
            }

            fetchData("/api/addresses", "IP Adressen konnten nicht geladen werden.", allAddresses => {
                const shared = (allAddresses || []).filter(entry =>
                    ownIps.has(entry.address) && entry.name !== filter
                )
                setSharedAddresses(shared)
            })
        })
    }, [permissions, filter])

    return (
        <div>
            <BasicTableComponent columns={columns} data={sharedAddresses} editUrlPart="address" />
        </div>
    )
}

export default SharedAddressList
